var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlignBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 18.875C4.5 18.5298 4.77982 18.25 5.125 18.25H18.875C19.2202 18.25 19.5 18.5298 19.5 18.875C19.5 19.2202 19.2202 19.5 18.875 19.5H5.125C4.77982 19.5 4.5 19.2202 4.5 18.875Z",
    fill: "#1A181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.875 17C13.1846 17 12.625 16.4404 12.625 15.75V8.25C12.625 7.55964 13.1846 7 13.875 7H17C17.6904 7 18.25 7.55964 18.25 8.25V15.75C18.25 16.4404 17.6904 17 17 17H13.875ZM13.875 8.25V15.75H17V8.25H13.875Z",
    fill: "#1A181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 5.125C5.75 4.43464 6.30964 3.875 7 3.875H10.125C10.8154 3.875 11.375 4.43464 11.375 5.125V15.75C11.375 16.4404 10.8154 17 10.125 17H7C6.30964 17 5.75 16.4404 5.75 15.75V5.125ZM10.125 5.125H7V15.75H10.125V5.125Z",
    fill: "#1A181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignBottom);
export default __webpack_public_path__ + "static/media/align-bottom.3a85dfccec8ca7c941712cf34e10cb1e.svg";
export { ForwardRef as ReactComponent };